import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQueue = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.9987 2C2.52594 2 1.33203 3.19391 1.33203 4.66667C1.33203 6.13943 2.52594 7.33333 3.9987 7.33333H11.9987C13.4715 7.33333 14.6654 6.13943 14.6654 4.66667C14.6654 3.19391 13.4715 2 11.9987 2H3.9987Z",
			fill: "#52525B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.9987 9.33333C1.63051 9.33333 1.33203 9.63181 1.33203 10C1.33203 10.3682 1.63051 10.6667 1.9987 10.6667H13.9987C14.3669 10.6667 14.6654 10.3682 14.6654 10C14.6654 9.63181 14.3669 9.33333 13.9987 9.33333H1.9987Z",
			fill: "#52525B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.9987 12.6667C1.63051 12.6667 1.33203 12.9651 1.33203 13.3333C1.33203 13.7015 1.63051 14 1.9987 14H13.9987C14.3669 14 14.6654 13.7015 14.6654 13.3333C14.6654 12.9651 14.3669 12.6667 13.9987 12.6667H1.9987Z",
			fill: "#52525B"
		})
	]
});
const ForwardRef = forwardRef(SvgQueue);
export default ForwardRef;
